import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ccffd2c8&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Header.vue?vue&type=style&index=1&id=ccffd2c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccffd2c8",
  null
  
)

component.options.__file = "Header.vue"
export default component.exports